__turbopack_context__.v({
  "Actions": "index-module__XK7bhG__Actions",
  "Backdrop": "index-module__XK7bhG__Backdrop",
  "Button": "index-module__XK7bhG__Button",
  "Description": "index-module__XK7bhG__Description",
  "Intro": "index-module__XK7bhG__Intro",
  "Popup": "index-module__XK7bhG__Popup",
  "PopupBody": "index-module__XK7bhG__PopupBody",
  "Textarea": "index-module__XK7bhG__Textarea",
  "TextareaContainer": "index-module__XK7bhG__TextareaContainer",
  "Title": "index-module__XK7bhG__Title",
});
